import { render, staticRenderFns } from "./reduce.vue?vue&type=template&id=a6f00b90&scoped=true&"
import script from "./reduce.vue?vue&type=script&lang=js&"
export * from "./reduce.vue?vue&type=script&lang=js&"
import style0 from "./reduce.vue?vue&type=style&index=0&id=a6f00b90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f00b90",
  null
  
)

export default component.exports